import Api from '../api';
const { axios: api } = Api;
const PREFIX = 'auth';

export const login = async (payload) => {
	const data = await api.post(`/${PREFIX}/login`, payload);
	return { data: data.data };
};

export const register = async (payload) => {
	const data = await api.post(`/${PREFIX}/register`, payload);
	return { data: data.data };
};

export const checkEmail = async (payload) => {
	const data = await api.post(`/${PREFIX}/check-email`, payload);
	return { data: data.data };
};
